'use es6';

import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { usageTrackerMiddleware } from 'usage-tracker-redux';
import { getUsageTracker } from 'developer-docs-shared-components/tracking/usageTracker';
import rootReducer from '../rootReducer';
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export default function configureStore(initialState = {}) {
  const tracker = getUsageTracker();
  const middlewares = [usageTrackerMiddleware(tracker), thunk];
  const createStoreWithMiddleware = composeEnhancers(applyMiddleware(...middlewares))(createStore);
  return createStoreWithMiddleware(rootReducer, initialState);
}